import axios from 'axios';
import Vue from 'vue';
import { Toast, Dialog } from 'vant';
import router from '@/router';
import store from '@/store';
import { getToken, removeToken, removeUserRegisterInfo } from '@/utils/auth'; //  预留写token获取方式
import { errorGoOutWeb } from '@/utils/thirdAuth'; //  token过期跳回或者小程序
import errorCode from '@/utils/errorCode'; // 错误信息的提示
import JSONBig from 'json-bigint';
Vue.use(Toast);
Vue.use(Dialog);

const thirdList = ['/exchange/center', '/exchange/list', '/exchange/exchange'];

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['language'] = 'en_US';// TWC特有需求
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 10000,
  // js超过16位精度丢失问题
  transformResponse: [function(data) {
    try {
      return JSONBig.parse(data);
    } catch (err) {
      return data;
    }
  }]
});

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false;
  const xsid = localStorage.getItem('xsid');
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  if (xsid !== undefined) {
    if (xsid === null) {
      config.headers['campusid'] = ''; // 多网校
    } else {
      config.headers['campusid'] = xsid; // 多网校
    }
  }
  if (window.location.href.indexOf('code=') > -1) {
    config.headers['ctype'] = 1;
  } else {
    config.headers['ctype'] = 0;
  }
  config.headers['Platform'] = 'H5';
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + '=';
      if (value !== null && typeof (value) !== 'undefined') {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            const params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + '=';
            url += subPart + encodeURIComponent(value[key]) + '&';
          }
        } else {
          url += part + encodeURIComponent(value) + '&';
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config;
}, error => {
  console.log(error);
  Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default'];
  console.log('2222', code);
  if (code === 400403) {
    let routerPath = router.history.current.path;
    if (thirdList.indexOf(routerPath) !== -1) {
      errorGoOutWeb();
    } else {
      Dialog.confirm({
        title: 'System Prompt',
        message: 'Your login session has expired. You can either stay on this page or log in again',
        confirmButtonText: 'Log in again',
        confirmButtonColor: '#0F47C1',
        className: 'logout-dialog'
      })
        .then(() => {
          removeUserRegisterInfo();
          store.commit('SET_TOKEN', '');
          removeToken();
          let isCode = location.href.indexOf('code=');
          if (isCode > -1) {
            let code = location.href.split('code=')[1].split('&')[0];
            location.href = '/login?code=' + code;
          } else {
            location.href = '/login';
          }
        })
        .catch(() => {
          // on cancel
        });
    }
  } else if (code === 400404) {
    Dialog.alert({
      message: 'Your current password is too simple. Please reset it. The password length must be at least 8 characters and include uppercase and lowercase letters and numbers',
      confirmButtonText: 'Reset Password',
      confirmButtonColor: '#0F47C1'
    }).then(() => {
      let isCode = location.href.indexOf('code=');
      if (isCode > -1) {
        let code = location.href.split('code=')[1].split('&')[0];
        location.href = `/code-login?code=${code}&type=forget`;
      } else {
        location.href = '/code-login?type=forget';
      }
    });
  } else if (code === 2000432) {
    Toast('The campus does not exist. Redirecting to the main campus website');
    setTimeout(() => {
      location.href = '/';
    }, 2000);
  } else if (code === 900040) {
    return res.data;
  } else if (code === 500) {
    Toast(msg);
    return Promise.reject(new Error(msg));
  } else if (code !== 200) {
    Toast(msg);
    return Promise.reject('error');
  } else {
    return res.data;
  }
},
error => {
  console.log('err' + error);
  let { message } = error;
  if (message === 'Network Error') {
    message = 'Backend API connection exception';
  } else if (message.includes('timeout')) {
    message = 'System API request timed out';
  } else if (message.includes('Request failed with status code')) {
    message = 'System interface' + message.substr(message.length - 3) + 'exception';
  }
  // Toast(message);
  return Promise.reject(error);
}
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js